<script lang="ts">
import {
  PhxsgIconProps as PhxsgCoreIconProps,
  PhxsgIcon as PhxsgCoreIcon,
} from '@sg-core/src/View/Components/Atoms/Icon';

export type PhxsgIconIds =
  | 'close'
  | 'bag'
  | 'chevron-right'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-up'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-down'
  | 'bag'
  | 'bag-active'
  | 'bookmark'
  | 'bookmark-active'
  | 'chat'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'close'
  | 'close-menu'
  | 'copy'
  | 'expand'
  | 'facebook'
  | 'info'
  | 'instagram'
  | 'linkedin'
  | 'menu'
  | 'pause'
  | 'pinterest'
  | 'play'
  | 'plus'
  | 'phone'
  | 'search'
  | 'sound-on'
  | 'sound-off'
  | 'tiktok'
  | 'triangle-down'
  | 'triangle-left'
  | 'triangle-right'
  | 'triangle-up'
  | 'user'
  | 'wishlist'
  | 'x-com'
  | 'youtube';

export type PhxsgIconProps = Omit<PhxsgCoreIconProps, 'id'> & { id: PhxsgIconIds };
</script>

<script setup lang="ts">
defineProps<PhxsgIconProps>();
</script>

<template>
  <PhxsgCoreIcon v-bind="$props" />
</template>

<style src="./icon.css"></style>
